/* eslint-disable import/no-anonymous-default-export */
import axios from 'axios';
import { API_URL, APIV, ENVIRONMENTS, REQUEST_RESPONSE_ENCRYPTION, SKIP_ENCRYPTION_ROUTE_KEYWORDS } from './../config/constant';
import secureStorage from './../config/encrypt';
import { toast } from 'react-toastify';
import CryptoJS from "crypto-js";
import forge from 'node-forge';

const decryptResponse = (encryptedResponse) => {
    try {
    const { encrypted_data, encrypted_symmetric_key, iv } = encryptedResponse;
    
    const responseAesKey = CryptoJS.enc.Utf8.parse(REQUEST_RESPONSE_ENCRYPTION.response_aes_key);
    
    const zeroIv = CryptoJS.lib.WordArray.create(new Array(4).fill(0));
    
    const decryptedSymmetricKeyBase64 = CryptoJS.AES.decrypt(
      encrypted_symmetric_key,
      responseAesKey,
      {
        iv: zeroIv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    ).toString(CryptoJS.enc.Utf8);
    
    const symmetricKey = CryptoJS.enc.Base64.parse(decryptedSymmetricKeyBase64);
    
    const ivWordArray = CryptoJS.enc.Base64.parse(iv);
    
    const decryptedData = CryptoJS.AES.decrypt(
      encrypted_data,
      symmetricKey,
      {
        iv: ivWordArray,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    ).toString(CryptoJS.enc.Utf8);

    return JSON.parse(decryptedData);
    
  } catch (error) {
    console.error('Decryption failed:', error);
    throw new Error('Failed to decrypt response');
  }
};

const encryptPayload = (data) => {
    try {
        const symmetricKey = CryptoJS.lib.WordArray.random(32);
        const iv = CryptoJS.lib.WordArray.random(16);

        const encryptedData = CryptoJS.AES.encrypt(
            JSON.stringify(data),
            symmetricKey,
            {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            }
        ).toString();

        const publicKey = forge.pki.publicKeyFromPem(REQUEST_RESPONSE_ENCRYPTION.publicKey);
        const symmetricKeyBytes = forge.util.hexToBytes(symmetricKey.toString(CryptoJS.enc.Hex));
        const encryptedSymmetricKey = forge.util.encode64(
            publicKey.encrypt(symmetricKeyBytes, 'RSA-OAEP')
        );

        return {
            encrypted_data: encryptedData,
            encrypted_symmetric_key: encryptedSymmetricKey,
            iv: iv.toString(CryptoJS.enc.Base64)
        };
    } catch (error) {
        console.error("Encryption failed: ", error);
        throw new Error("Failed to encrypt response");
    }
}

const Axios = axios.create();

Axios.interceptors.request.use((config) => {
    config["isFormDataPayload"] = config.data instanceof FormData;
    config["isEncryptionRequired"] = process.env.REACT_APP_ENV !== ENVIRONMENTS.LOCAL && !SKIP_ENCRYPTION_ROUTE_KEYWORDS.some(keyword => config.url.includes(keyword));
    
    if (config["isEncryptionRequired"] && !config["isFormDataPayload"] && config.data && Object.keys(config.data).length) {
        config.data = encryptPayload(config.data);
    }
    
    return config;
}, (error) => {
    return Promise.reject(error);
});

Axios.interceptors.response.use(
    (response) => {
        if (response.config["isEncryptionRequired"]) {
            response.data = decryptResponse(response.data);
        }
        return response;
    },
    (error) => {
        if (error.response && +error.response.status === 401) {
            secureStorage.removeItem('authUserInfo');
            window.location.href = '/login';
        }

        if (error?.response?.config?.["isEncryptionRequired"] && error?.response?.data) {
            error.response.data = decryptResponse(error.response.data);
        }

        return error.response;
    });

window.commonErrorToast = function (error) {
    if (typeof error == "string") toast.error(error);
    else if (error.message) toast.error("Helllo", error.message);
}
export default {
    getMasters(list) {
        return this.get("/core/commonservice/master", { master: list });
    },
    getToken() {
        return (secureStorage.getItem('authUserInfo') && secureStorage.getItem('authUserInfo')['token'])
            ? secureStorage.getItem('authUserInfo')['token']
            : ''
    },
    delete(URL, body, headers) {
        headers = headers || {};
        if (APIV) headers['apiv'] = APIV;
        headers['Authorization'] = this.getToken();
        headers['Accept-Language'] = secureStorage.getItem('lang') || 'en';
        URL = (URL[0] === '/') ? URL.substr(1) : URL;
        return Axios.delete(`${API_URL.GETWAY_API}${URL}`, body, { headers })
    },
    post(URL, body, headers) {
        headers = headers || {};
        if (APIV) headers['apiv'] = APIV;
        headers['Authorization'] = this.getToken();
        headers['Accept-Language'] = secureStorage.getItem('lang') || 'en';
      //  headers['apikey'] = API_URL.API_KEY;
        URL = (URL[0] === '/') ? URL.substr(1) : URL;
        return Axios.post(`${API_URL.GETWAY_API}${URL}`, body, { headers })
    },
    put(URL, body, headers) {
        headers = headers || {};
        if (APIV) headers['apiv'] = APIV;
        headers['Authorization'] = this.getToken();
        headers['Accept-Language'] = secureStorage.getItem('lang') || 'en';
        URL = (URL[0] === '/') ? URL.substr(1) : URL;
        return Axios.put(`${API_URL.GETWAY_API}${URL}`, body, { headers })
    },
    get(URL, query, headers) {
        headers = headers || {};
        if (APIV) headers['apiv'] = APIV;
        headers['Authorization'] = this.getToken();
        headers['Accept-Language'] = secureStorage.getItem('lang') || 'en';
        //headers['apikey'] = API_URL.API_KEY;
        URL = (URL[0] === '/') ? URL.substr(1) : URL;
        return Axios.get(`${API_URL.GETWAY_API}${URL}`,
            { params: query, headers })
    },
    uploadFilesToS3(postdata, headers) {
        headers = headers || {};
        return axios.post(
          `${API_URL.COMMON_GATEWAY_API}core/commonservice/docs_upload`,
          postdata,
          { headers }
        );
      },
}